<template>
    <div>
        <b-modal id="matterMediationFormModal" ref="matterMediationFormModal" centered size="xl" no-close-on-backdrop :title= "$t('matter.matter_mediation')"  hide-footer>
            <b-card>
            <b-row>
                <b-col>
                    <div class="custom-search d-flex justify-content-end">
                        <b-button variant="outline-primary" size="sm"  @click.prevent="addOrUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <validation-observer ref="simpleRules">
                    <b-form>
                        <label>{{ $t('matterMediation.matter_sub_type') }}</label>
                        <validation-provider v-slot="{ errors }" :name="$t('matterMediation.matter_sub_type')" :rules="{ excluded:0}" >
                            <b-form-select  size="sm" v-model="matterSubTypeSelect" value-field="id" text-field="name" :options="matterSubTypeOptions" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                    </validation-observer>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.filed_on') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="filedOn" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('others.select')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.case_number') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="caseNumber" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.file_submission_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="fileSubmissionDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('others.select')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <label style= "white-space: nowrap;">{{ $t('matterMediation.remaining_time_to_file_a_law_suit') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="remainingTimeToFileALawsuit"/>
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.authority_mediation_office') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="authorityMediationOfficeSelect" value-field="id" text-field="name" :options="authorityMediationOfficeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.authority_representative') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="authorityRepresentativeSelect" value-field="id" text-field="name" :options="authorityRepresentativeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.counter_party') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="counterPartySelect" value-field="id" text-field="name" :options="counterPartyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.counter_party_attorney') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="counterPartyAttorneySelect" value-field="id" text-field="name" :options="counterPartyAttorneyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label style= "white-space: nowrap;">{{ $t('matterMediation.invitation_letter_received_on') }}</label>
                        <b-form-group >
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="invitationLetterReceivedOn" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('others.select')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.authority_court') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="authorityCourtSelect" value-field="id" text-field="name" :options="authorityCourtOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
               <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.court_objection_result') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="courtObjectionResultSelect" value-field="id" text-field="name" :options="courtObjectionResultOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.case_closure_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="caseClosureDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('others.select')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.extension_deadline') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="extensionDeadline" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('others.select')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.last_meeting_date') }}</label>
                        <b-form-group>
                              
                            <b-form-datepicker disabled today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="lastMeetingDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('others.select')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.mediation_result') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="mediationResultSelect" value-field="id" text-field="name" :options="mediationResultOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.agreement_amount') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" v-model="agreementAmount" type="number" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.agreement_currency') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="agreementCurrencySelect" value-field="id" text-field="name" :options="agreementCurrencyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.agreement_payment_method_type') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="agreementLawPaymentMethodTypeSelect" value-field="id" text-field="name" :options="agreementLawPaymentMethodTypeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.collection_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="collectionDate"  defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('others.select')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterMediation.penalty_clause_amount') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="penaltyClauseAmount" type="number" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-3">
                    <b-form>
                         <label >{{ $t('matterMediation.penalty_clause_currency') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="penaltyClauseCurrencySelect" value-field="id" text-field="name" :options="penaltyClauseCurrencyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                        <b-form>
                            <label>{{ $t('matter.process_result') }}</label>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                        <label>{{ $t('matterMediation.note') }}</label>
                        <b-form-textarea :placeholder=" $t('matterMediation.note')" rows="3" v-model="note" maxlength="250" />
                </b-col>
            </b-row>
           </b-card>
            <b-card v-show="id > 0">
          <b-row>
            <b-col class="mt-2">
              <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                <b-tab :title="$t('Law Event')" style="width: 100%">
                  <b-card-text>
                    <law-event-list ref="lawEventList" :matterTypeHistoryId="matterTypeHistoryId" @parentEvent = setLastMeetingDate></law-event-list>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
      </b-card>
    
    </b-modal>
    </div>
</template>

<script>

export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            matterSubTypeOptions:[],
            matterSubTypeSelect: 0,
            filedOn: null,
            caseNumber: '',
            fileSubmissionDate: null,
            remainingTimeToFileALawsuit: 0,
            authorityMediationOfficeOptions:[],
            authorityMediationOfficeSelect:0,
            authorityRepresentativeOptions:[],
            authorityRepresentativeSelect: 0,
            counterPartyOptions: [],
            counterPartySelect: 0,
            counterPartyAttorneyOptions:[],
            counterPartyAttorneySelect: 0,
            invitationLetterReceivedOn: null,
            authorityCourtOptions: [],
            authorityCourtSelect: 0,
            courtObjectionResultOptions:[],
            courtObjectionResultSelect: 0,
            caseClosureDate: null,
            extensionDeadline: null,
            lastMeetingDate: null,
            mediationResultOptions: [],
            mediationResultSelect: 0,
            agreementAmount: 0,
            agreementCurrencyOptions:[],
            agreementCurrencySelect: 0,
            agreementLawPaymentMethodTypeOptions:[],
            agreementLawPaymentMethodTypeSelect: 0,
            collectionDate: null,
            penaltyClauseAmount: 0,
            penaltyClauseCurrencyOptions:[],
            penaltyClauseCurrencySelect: 0,
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
            note: '',
            matterTypeHistoryId: 0,
            previousMeetingDate: null,
            empId: 0,
            enableWatch: false
        }
    },
    
    watch: {
        fileSubmissionDate(newVal) {
            if (newVal && !this.id) {
            const submissionDate = new Date(newVal);

            const caseClosure = new Date(submissionDate);
            caseClosure.setDate(caseClosure.getDate() + 42);

            const extensionDeadline = new Date(submissionDate);
            extensionDeadline.setDate(extensionDeadline.getDate() + 56);

            this.caseClosureDate = caseClosure;
            this.extensionDeadline = extensionDeadline;
            }
        },
           async lastMeetingDate(newVal,oldVal){
            
            if (newVal !== oldVal && this.enableWatch){
                
                    if(newVal) newVal = this.$AddDaysWithWeekend(newVal,this.remainingTimeToFileALawsuit);
                    if(oldVal) oldVal = this.$AddDaysWithWeekend(oldVal,this.remainingTimeToFileALawsuit);
                
                    const lawReminderResponse = await this.upsertLawReminder({
                        lawMatterId: this.lawMatterId,
                        nextRenewalDate:  newVal,
                        previousRenewalDate: oldVal,
                        employeeId: this.empId,
                        note: this.$t('matterMediation.reminder_note'),
                    });
                    if (!lawReminderResponse.data.resultStatus) {
                         this.$WarningAlert(lawReminderResponse.data.resultMessage);
                        }
                }
        }
    },
    methods: {
        setLastMeetingDate(payload){
            this.lastMeetingDate = payload
        },
        async showMediation(id, lawMatterId,employeeId,matterTypeHistoryId) {
            this.$refs['matterMediationFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            this.matterTypeHistoryId = matterTypeHistoryId;
            this.empId = employeeId

            const data = {  id: this.id }
            const controller = { name: 'LawMatterMediation' }
            const payload = { data: data,controller: controller}
            
            const response = await  this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {

                        this.matterSubTypeOptions = response.data.lawMatterSubTypeList
                        this.matterSubTypeOptions.splice(0, 0, this.$nullSelected())
                        this.matterSubTypeSelect = response.data.lawMatterMediation.lawMatterSubTypeId

                        this.filedOn = response.data.lawMatterMediation.filedOn
                        this.caseNumber = response.data.lawMatterMediation.caseNumber
                        this.fileSubmissionDate = response.data.lawMatterMediation.fileSubmissionDate
                        this.remainingTimeToFileALawsuit = response.data.lawMatterMediation.remainingTimeToFileALawsuit

                        this.authorityMediationOfficeOptions = response.data.lawAuthorityMediationOfficeList
                        this.authorityMediationOfficeOptions.splice(0, 0, this.$nullSelected())
                        this.authorityMediationOfficeSelect = response.data.lawMatterMediation.lawAuthorityMediationOfficeId
                        
                        this.authorityRepresentativeOptions = response.data.lawAuthorityRepresentativeList
                        this.authorityRepresentativeOptions.splice(0, 0, this.$nullSelected())
                        this.authorityRepresentativeSelect = response.data.lawMatterMediation.lawAuthorityRepresentativeId

                        this.counterPartyOptions = response.data.lawCounterPartyList
                        this.counterPartyOptions.splice(0, 0, this.$nullSelected())
                        this.counterPartySelect = response.data.lawMatterMediation.lawCounterPartyId

                        this.counterPartyAttorneyOptions = response.data.lawCounterPartyAttorneyList
                        this.counterPartyAttorneyOptions.splice(0, 0, this.$nullSelected())
                        this.counterPartyAttorneySelect = response.data.lawMatterMediation.lawCounterPartyAttorneyId

                        this.invitationLetterReceivedOn = response.data.lawMatterMediation.invitationLetterReceivedOn

                        this.authorityCourtOptions = response.data.lawAuthorityCourtList
                        this.authorityCourtOptions.splice(0, 0, this.$nullSelected())
                        this.authorityCourtSelect = response.data.lawMatterMediation.lawAuthorityCourtId

                        this.courtObjectionResultOptions = response.data.lawCourtObjectionResultList
                        this.courtObjectionResultOptions.splice(0, 0, this.$nullSelected())
                        this.courtObjectionResultSelect = response.data.lawMatterMediation.lawCourtObjectionResultId

                        this.caseClosureDate = response.data.lawMatterMediation.caseClosureDate
                        this.extensionDeadline = response.data.lawMatterMediation.extensionDeadline
        
                        this.mediationResultOptions = response.data.lawMediationResultList
                        this.mediationResultOptions.splice(0, 0, this.$nullSelected())
                        this.mediationResultSelect = response.data.lawMatterMediation.lawMediationResultId

                        this.agreementAmount = response.data.lawMatterMediation.agreementAmount

                        this.agreementCurrencyOptions = response.data.agreementCurrencyList
                        this.agreementCurrencyOptions.splice(0, 0, this.$nullSelected())
                        this.agreementCurrencySelect = response.data.lawMatterMediation.agreementCurrencyId

                        this.agreementLawPaymentMethodTypeOptions = response.data.agreementLawPaymentMethodTypeList
                        this.agreementLawPaymentMethodTypeOptions.splice(0, 0, this.$nullSelected())
                        this.agreementLawPaymentMethodTypeSelect = response.data.lawMatterMediation.agreementLawPaymentMethodTypeId

                        this.collectionDate = response.data.lawMatterMediation.collectionDate
                        this.penaltyClauseAmount = response.data.lawMatterMediation.penaltyClauseAmount

                        this.penaltyClauseCurrencyOptions = response.data.penaltyClauseCurrencyList
                        this.penaltyClauseCurrencyOptions.splice(0, 0, this.$nullSelected())
                        this.penaltyClauseCurrencySelect = response.data.lawMatterMediation.penaltyClauseCurrencyId

                        this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                        this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                        this.lawMatterProcessResultSelect = response.data.lawMatterInfo.lawMatterProcessResultId


                        this.note = response.data.lawMatterMediation.note
                        this.previousMeetingDate = this.lastMeetingDate
                        this.enableWatch = true
                    
                } else {
                    this.$bvModal.hide('matterMediationFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
          
        },
        async addOrUpdate() {
            const lawMatterMediationData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            lawMatterSubTypeId: this.matterSubTypeSelect,
                            filedOn: this.filedOn,
                            caseNumber: this.caseNumber,
                            fileSubmissionDate: this.fileSubmissionDate,
                            remainingTimeToFileALawsuit: this.remainingTimeToFileALawsuit,
                            lawAuthorityMediationOfficeId: this.authorityMediationOfficeSelect,
                            lawAuthorityRepresentativeId : this.authorityRepresentativeSelect,
                            lawCounterPartyId: this.counterPartySelect,
                            lawCounterPartyAttorneyId:  this.counterPartyAttorneySelect,
                            invitationLetterReceivedOn: this.invitationLetterReceivedOn,
                            lawAuthorityCourtId : this.authorityCourtSelect,
                            lawCourtObjectionResultId : this.courtObjectionResultSelect,
                            caseClosureDate: this.caseClosureDate,
                            extensionDeadline: this.extensionDeadline,
                            lawMediationResultId: this.mediationResultSelect,
                            agreementAmount: this.agreementAmount,
                            agreementCurrencyId : this.agreementCurrencySelect,
                            agreementLawPaymentMethodTypeId : this.agreementLawPaymentMethodTypeSelect,
                            collectionDate: this.collectionDate,
                            penaltyClauseAmount: this.penaltyClauseAmount,
                            penaltyClauseCurrencyId : this.penaltyClauseCurrencySelect,
                            note: this.note,
                            lawMatterProcessResultId :this.lawMatterProcessResultSelect
                        }

            const controller = { name: 'LawMatterMediation' }
            const payload = {data: lawMatterMediationData,controller: controller}
            const success = await this.$refs.simpleRules.validate()
            if(success){
                var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                     const historyId = await this.$SaveLawMatterMatterTypeHistory(10, this.id, this.lawMatterId,this.employeeId)
                      if(!this.matterTypeHistoryId){
                        this.matterTypeHistoryId = historyId
                      }
                    this.getMatterTypeHistoryList()
                }
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        }
            
        },
        async upsertLawReminder(data){
           const  controller = { name: 'LawReminder',actionName:'UpsertLawReminderByLawMatter'}
           const payload = { data: data, controller: controller}
           const response = await this.$store.dispatch('moduleAuth/customService', payload)
           return response;
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>